export default __webpack_public_path__ + "static/media/black-round-arrow.4b9dd190.svg";